export default __webpack_public_path__ + "static/media/resource-room-featured-image-placeholder.b9023495.svg";